import i from 'icepick'
import { keyBy } from 'lodash'
import analytics from 'features/Analytics/Analytics.utils'

const initialState = {
  flowsById: {},
  flows: [],
  flowsLoading: false,

  triggers: [],
  triggersLoading: [],

  templates: [],
  templatesLoading: [],

  flowLogs: {},
  flowLogsById: {},

  pricing: {},
  pricingLoading: false,
  savePending: false,
  publishPending: false,
  createLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FLOWS/LIST_TRIGGERS_PENDING':
      return i.assoc(state, 'triggersLoading', true)
    case 'FLOWS/LIST_TRIGGERS_REJECTED':
      return i.assoc(state, 'triggersLoading', false)
    case 'FLOWS/LIST_TRIGGERS_FULFILLED':
      return i
        .chain(state)
        .assoc('triggers', action.payload.data)
        .assoc('triggersLoading', false)
        .value()

    case 'FLOWS/LIST_TEMPLATES_PENDING':
      return i.assoc(state, 'templatesLoading', true)
    case 'FLOWS/LIST_TEMPLATES_REJECTED':
      return i.assoc(state, 'templatesLoading', false)
    case 'FLOWS/LIST_TEMPLATES_FULFILLED':
      return i
        .chain(state)
        .assoc('templates', action.payload.data)
        .assoc('templatesLoading', false)
        .value()

    case 'FLOWS/SAVE_FLOW_PENDING':
      return i.assoc(state, 'savePending', true)
    case 'FLOWS/SAVE_FLOW_REJECTED':
      return i.assoc(state, 'savePending', false)
    case 'FLOWS/SAVE_FLOW_FULFILLED':
      analytics.track('Flows - Save', action.payload.data)
      return i
        .chain(state)
        .assocIn(['flowsById', action.payload.data.id], action.payload.data)
        .assoc('savePending', false)
        .value()

    case 'FLOWS/PUBLISH_FLOW_PENDING':
      return i.assoc(state, 'publishPending', true)
    case 'FLOWS/PUBLISH_FLOW_REJECTED':
      return i.assoc(state, 'publishPending', false)
    case 'FLOWS/PUBLISH_FLOW_FULFILLED':
      analytics.track('Flows - Publish', action.payload.data)
      return i
        .chain(state)
        .assocIn(['flowsById', action.payload.data.id], action.payload.data)
        .assoc('publishPending', false)
        .value()

    case 'FLOWS/GET_FLOW_FULFILLED':
      return i.assocIn(state, ['flowsById', action.payload.data.id], action.payload.data)

    case 'FLOWS/CREATE_FLOW_PENDING':
      return i.assoc(state, 'createLoading', true)
    case 'FLOWS/CREATE_FLOW_REJECTED':
      return i.assoc(state, 'createLoading', false)
    case 'FLOWS/CREATE_FLOW_FULFILLED':
      analytics.track('Flows - Create', action.payload.data)
      return i
        .chain(state)
        .updateIn(['flows'], flows => i.push(flows, action.payload.data.id))
        .assocIn(['flowsById', action.payload.data.id], action.payload.data)
        .assoc('createLoading', false)
        .value()

    case 'FLOWS/GET_FLOWS_PENDING':
      return i.assoc(state, 'flowsLoading', true)
    case 'FLOWS/GET_FLOWS_REJECTED':
      return i.assoc(state, 'flowsLoading', false)
    case 'FLOWS/GET_FLOWS_FULFILLED':
      return i
        .chain(state)
        .assocIn(
          ['flows'],
          action.payload.data.map(item => item.id)
        )
        .assocIn(['flowsById'], keyBy(action.payload.data, 'id'))
        .assoc('flowsLoading', false)
        .value()

    case 'FLOWS/DELETE_FLOW_FULFILLED':
      analytics.track('Flows - Delete', action.payload.data)
      return i.updateIn(state, ['flows'], flows =>
        flows.filter(flowId => flowId !== action.meta.flowId)
      )

    case 'FLOWS/GET_PRICING_PENDING':
      return i.assoc(state, 'pricingLoading', true)
    case 'FLOWS/GET_PRICING_REJECTED':
      return i.assoc(state, 'pricingLoading', false)
    case 'FLOWS/GET_PRICING_FULFILLED':
      return i
        .chain(state)
        .assoc('pricing', action.payload.data)
        .assoc('pricingLoading', false)
        .value()

    case 'FLOWS/GET_FLOW_LOGS_PENDING':
      return i.assocIn(state, ['flowLogs', action.meta.cacheKey, 'loading'], true)
    case 'FLOWS/GET_FLOW_LOGS_REJECTED':
      return i.assocIn(state, ['flowLogs', action.meta.cacheKey, 'loading'], false)
    case 'FLOWS/GET_FLOW_LOGS_FULFILLED':
      return i
        .chain(state)
        .assocIn(['flowLogs', action.meta.cacheKey, 'data'], {
          ...action.payload.data,
          results: action.payload.data.results.map(log => log.id),
        })
        .updateIn(['flowLogsById'], flowLogs => ({
          ...flowLogs,
          ...keyBy(
            action.payload.data.results.map(data => ({ data })),
            'data.id'
          ),
        }))
        .assocIn(['flowLogs', action.meta.cacheKey, 'loading'], false)
        .value()

    case 'FLOWS/GET_FLOW_LOG_PENDING':
      return i.assocIn(state, ['flowLogsById', action.meta.flowLogId, 'loading'], true)
    case 'FLOWS/GET_FLOW_LOG_REJECTED':
      return i.assocIn(state, ['flowLogsById', action.meta.flowLogId, 'loading'], false)
    case 'FLOWS/GET_FLOW_LOG_FULFILLED':
      return i
        .chain(state)
        .assocIn(['flowLogsById', action.meta.flowLogId, 'data'], action.payload.data)
        .assocIn(['flowLogsById', action.meta.flowLogId, 'loading'], false)
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flows.reducer.js